import { useState, useRef } from "react";
import API from '../Services/AddPackage'
import LocationList from "../Components/Location";
import { ToastContainer, toast } from "react-toastify";
import AddPackageList from "../Components/AddPackageList";
import CenterModal from '../Components/CenterModal'
import PackageDescription from "../Components/PackageDescription";

const AddPackage = () => {
    const [name, setName] = useState("")
    const [locationId, setLocationId] = useState("")
    const [type, setType] = useState("")
    const [amount, setAmount] = useState("")
    const [weakendAmount, setWeakendAmount] = useState("")
    const [time, setTime] = useState("")
    const [description, setDescription] = useState([""]);
    const [errors, setErrors] = useState({});
    const summernoteRef = useRef(null);
    const [editorValue, setEditorValue] = useState('');
    const[specialAmount, setSpecialAmount]=useState("");

    const [weekdays, setWeekdays] = useState({
        Sunday: false,
        Monday: false,
        Tuesday: false,
        Wednesday: false,
        Thursday: false,
        Friday: false,
        Saturday: false,
    });
    const [allDaysChecked, setAllDaysChecked] = useState(false);

    const [selectedCenter, setSelectedCenter] = useState([]);

    const handleFieldChange = (e, fieldName) => {
        const value = e.target.value;
        if (value.trim()) {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[fieldName];
                return updatedErrors;
            });
        }

        switch (fieldName) {
            case "name":
                setName(value);
                break;
            case "locationId":
                setLocationId(value);
                break;
            case "type":
                setType(value);
                break;
            case "amount":
                setAmount(value);
                break;
            case "weakendAmount":
                setWeakendAmount(value);
                break;
            case "time":
                setTime(value);
                break;
            case "description":
                setDescription(value);
                break;
                 case "specialAmount":
                setSpecialAmount(value);
                break;
        }
    }
    const validateFields = () => {
        const errors = {};
        if (!name) {
            errors.name = "Name is required";
        } else if (!/^[A-Za-z\s]+$/.test(name)) {
            errors.name = "Name can only contain letters and spaces";
        }
        if (!selectedCenter) { errors.selectedCenter = "Center is required" }
        if (!amount.trim()) {
            errors.amount = "Amount is required";
        } else if (!/^\d+$/.test(amount.trim())) {
            errors.amount = "Amount must be a numeric value";
        } else if (parseInt(amount, 10) === 0) {
            errors.amount = "Amount must be greater than 0";
        }

        if (!description) { errors.description = "Description is required" }
        setErrors(errors);
        return Object.keys(errors).length === 0;
    }

    const addPackage = async () => {
        const editorContent = summernoteRef.current?.getContent?.() || "";
        const location_id = Array.isArray(selectedCenter)

            ? selectedCenter.join(", ")
            : selectedCenter;
        // console.log("........", selectedCenter)
        const isMultiple = location_id.length === 1 ? 0 : 1;

        const payload = {
            name: name,
            // location_id: parseInt(locationId),
            location_id: location_id,
            type: 'food',
            amount_per_person: parseFloat(amount),
            weekend_addon_amount: parseFloat(0),
            description: editorContent,
            // description:description,
            time: parseInt(0),
            week_days: 'All Days',
            is_multiple: isMultiple,
            special_price:specialAmount
        }
       // console.log("payload data...", payload)
        try {
            const response = await API.createPackage(payload)
           // console.log("create package response....", response?.data)
            toast.success(response?.data?.message || "Package created successfully!");
            setTimeout(() => window.location.reload(), 2000);
        } catch (error) {
            handleError(error);
            if (error.response.status == 403) {
                window.location.replace("/Login");
            }
            console.log("error", error)
        }

    }
    const handleError = (error) => {
        console.error("Error:", error);
        if (error.response) {
            toast.error(error.response.data?.message || `Error: ${error.response.status}`);
        } else if (error.request) {
            toast.error("No response from server. Please try again later.");

        } else {
            toast.error("Something went wrong. Please try again.");
        }
    };

    const handleSubmit = async () => {
        if (!validateFields()) return;
        await addPackage();

    };

    const handleCancel = () => {
        setName("")
        setLocationId("")
        setType("")
        setAmount("")
        // setWeakendAmount("")
        setTime("")
        setDescription([""])
        // setWeekdays("")
    }
    const handleSelectedCenter = (selectedData) => {
        setSelectedCenter(selectedData);
    };

    return (
        <div>
            <div className="col-12 grid-margin stretch-card">
                <div className="card">
                    <div className="card-body">
                        <h4 className="card-title">Add Food Package</h4>
                        <div className="forms-sample">
                            <div className="row">
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label htmlFor="name">Name <span style={{ color: "red" }}>*</span></label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="txtname"
                                            placeholder="Name"
                                            value={name}
                                            onChange={(e) => handleFieldChange(e, "name")}
                                        />
                                        {errors.name && <span className="text-danger" style={{ fontSize: "12px" }}>{errors.name}</span>}

                                    </div>
                                </div>
                                <div className="col-md-3">

                                    <CenterModal onSelectCenter={handleSelectedCenter} />

                                </div>
                              

                            {/* </div>
                            <div className="row"> */}
                                  <div className="col-md-3">
                                    <div className="form-group">
                                        <label htmlFor="name">MRP (Normal) <span style={{ color: "red" }}>*</span></label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="txtamount"
                                            placeholder="Amount"
                                            value={amount}
                                            onChange={(e) => handleFieldChange(e, "amount")}
                                        />
                                        {errors.amount && <span className="text-danger" style={{ fontSize: "12px" }}>{errors.amount}</span>}
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label htmlFor="name">MRP (SPCL) </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="txtamount"
                                            placeholder="specialAmount"
                                            value={specialAmount}
                                            onChange={(e) => handleFieldChange(e, "specialAmount")}
                                        />
                                        {errors.amount && <span className="text-danger" style={{ fontSize: "12px" }}>{errors.amount}</span>}
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <PackageDescription ref={summernoteRef} initialValue={editorValue} />
                            </div>

                            <div className="mt-3">

                                <button
                                    onClick={handleSubmit}
                                    type="button"
                                    className="btn btn-primary">
                                    Submit
                                </button>
                                <button onClick={handleCancel} className="btn btn-light ms-2">Cancel</button>

                            </div>

                        </div>

                    </div>
                </div>
            </div>
            <AddPackageList />
            <ToastContainer />
        </div>
    )

}
export default AddPackage;